import React, { useEffect, useRef, useState } from 'react'
import ChipMenuOption from './ChipMenuOption'

const ChipsMenu = ({
  options,
  menuClassName,
  optionClassName,
  optionActiveClassName,
  optionBackgroundClassName
} = {}) => {
  const [activeOptionId, setActiveOptionId] = useState(null)
  const backgroundRef = useRef(null)
  const menuRef = useRef(null)

  const setBackgroundPositionFromElement = (element) => {
    backgroundRef.current.style.top = element.offsetTop + 'px'
    backgroundRef.current.style.left = element.offsetLeft + 'px'
    backgroundRef.current.style.width = element.offsetWidth + 'px'
  }

  useEffect(() => {
    if (!menuRef.current) {
      return
    }
    const firstButton = menuRef.current.getElementsByTagName('button')[0]
    //workaround for the first button not being set correctly
    if (firstButton.offsetTop < 0) {
      setTimeout(() => {
        setBackgroundPositionFromElement(firstButton)
      }, 400)
    } else {
      setBackgroundPositionFromElement(firstButton)
    }
  }, [])

  return (
    <div
      ref={menuRef}
      className={`relative ${menuClassName}`}
    >
      <span
        className={`absolute h-[36px] rounded-full px-3 py-1.5 text-sm font-medium tracking-[0.15px] transition-all duration-300 ease-in-out ${optionBackgroundClassName}`}
        ref={backgroundRef}
      />

      {options.map((option) => {
        return (
          <ChipMenuOption
            key={option.id}
            className={`relative ${optionClassName} `}
            activeClassName={optionActiveClassName}
            isActive={option.id === activeOptionId}
            onClick={(event) => {
              setActiveOptionId(option.id)
              option.onClick({ id: option.id })
              setBackgroundPositionFromElement(event.target)
            }}
          >
            {option.title}
          </ChipMenuOption>
        )
      })}
    </div>
  )
}

export default ChipsMenu
